(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const announcement = document.querySelector('.shopify-section.announcement');
  const closeBtn = announcement?.querySelector('.announcement-close-btn');

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      announcement.style.display = 'none';
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const swiperEl = document.querySelector('.marquee-swiper');

  // Initialize Swiper
  const marqueeSwiper = new Swiper(swiperEl, {
    slidesPerView: 'auto',
    spaceBetween: 0,
    freeMode: true,
    freeModeMomentum: true,
    allowTouchMove: true, // enable drag
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    
    speed: 800, // smooth animation
  });

  let animationId;
  const speed = 0.5; // pixels per frame for marquee scroll

  // Start auto-scrolling
  function startMarquee() {
    cancelAnimationFrame(animationId);

    function step() {
      let current = marqueeSwiper.getTranslate();
      current -= speed;

      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      const totalWidth = wrapper.scrollWidth;
      const visibleWidth = swiperEl.offsetWidth;

      // Reset loop
      if (Math.abs(current) >= totalWidth - visibleWidth) {
        current = 0;
      }

      marqueeSwiper.setTranslate(current);
      animationId = requestAnimationFrame(step);
    }

    step();
  }

  function stopMarquee() {
    cancelAnimationFrame(animationId);
  }

  // Pause while hovering or dragging
  swiperEl.addEventListener('mouseenter', stopMarquee);
  swiperEl.addEventListener('mouseleave', startMarquee);

  marqueeSwiper.on('touchStart', stopMarquee);
  marqueeSwiper.on('touchEnd', startMarquee);

  // Start automatically
  startMarquee();
});

// Cursor text handlers (attach via addEventListener, not inline)
function handleMoveText(event) {
  const div = event.currentTarget;
  const text = div.querySelector(".cursor-text");
  if (!text) return;

  // use pageX/Y to handle any scrolling; clientX also works
  const rect = div.getBoundingClientRect();
  const offsetX = event.clientX - rect.left - text.offsetWidth / 2;
  const offsetY = event.clientY - rect.top - text.offsetHeight / 2;

  text.style.left = offsetX + "px";
  text.style.top = offsetY + "px";
  text.style.display = "block";
}

function handleHideText(event) {
  const text = event.currentTarget.querySelector(".cursor-text");
  if (!text) return;
  text.style.display = "none";
}

// attach listeners after DOM ready (we're already inside DOMContentLoaded)
const arrowDivs = document.querySelectorAll('.custom-arrow-div');
arrowDivs.forEach(div => {
  div.addEventListener('mousemove', handleMoveText);
  div.addEventListener('mouseleave', handleHideText);
  // also hide when pointer leaves the whole window or mouse-up elsewhere
  div.addEventListener('mouseup', handleHideText);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
const swiper = new Swiper(".testimonials-section .swiper", {
  loop: true,
  centeredSlides: false,
  arrows: false,
  slidesPerView: 1,
  spaceBetween: 20,
  breakpoints: {
    640: { slidesPerView: 2, spaceBetween: 30 },
    992: { slidesPerView: 3, spaceBetween: 40 }
  },
  pagination: { el: ".testimonials-section .swiper-pagination", clickable: true },
});

  } catch(e) { console.error(e); }
})();
})();
